import styled from 'styled-components'

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin: 1rem 0 0;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
`

export const ToolbarLeft = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
`

export const Segmented = styled.div`
  display: inline-flex;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 6px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background};
`

export const SegmentButton = styled.button`
  margin: 0;
  padding: 0.35rem 0.75rem;
  border: none;
  border-right: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ $active, theme }) => {
    if (!$active) return 'transparent'
    return theme.name === 'dark'
      ? 'rgba(62, 207, 142, 0.14)'
      : 'rgba(62, 207, 142, 0.1)'
  }};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.action.primary.bg : theme.colors.textSecondary};
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;

  &:last-child {
    border-right: none;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.action.primary.bg};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.primary.bg};
    outline-offset: -2px;
  }
`

export const TabHint = styled.p`
  margin: 0.5rem 0 0;
  font-size: 0.6875rem;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.35;
`
